export const DISCONNECT_GL_ERROR = "Error in disconnecting General Ledger.";
export const DISCONNECT_GL_SUCCESS = "General Ledger disconnected successfully.";
export const SYNC_GL_ERROR = "Error in syncing Chart of Accounts.";
export const SYNC_GL_SUCCESS = "Chart of Accounts synced";
export const SAVE_MAPPING_ERROR = "Error in saving mapping.";
export const SAVE_MAPPING_SUCCESS = "Mapping saved successfully.";
